import formatISO from 'date-fns/formatISO';

/**
 * @deprecated use formatDateIso instead
 */
export function formatDayISO(date: Date): string {
  return formatISO(date, { representation: 'date' });
}
